import type { FC, SVGProps } from 'react';

const ScatteredCloudsIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16841 5.68073C3.20583 2.72143 5.61642 0.333984 8.58464 0.333984C10.906 0.333984 12.8846 1.7936 13.656 3.84397C15.7763 4.4237 17.3346 6.36282 17.3346 8.66732C17.3346 11.4287 15.0961 13.6673 12.3346 13.6673H4.83464C2.53345 13.6673 0.667969 11.8018 0.667969 9.50065C0.667969 7.79115 1.69687 6.32357 3.16841 5.68073ZM8.58464 2.00065C6.51357 2.00065 4.83464 3.67958 4.83464 5.75065C4.83464 5.89157 4.84237 6.03032 4.85738 6.16665C4.90375 6.5879 4.63057 6.97382 4.22506 7.07532C3.13854 7.34723 2.33464 8.33107 2.33464 9.50065C2.33464 10.8814 3.45393 12.0007 4.83464 12.0007H12.3346C14.1756 12.0007 15.668 10.5082 15.668 8.66732C15.668 7.01273 14.4616 5.63832 12.8806 5.37832C12.5558 5.32494 12.2911 5.08679 12.2047 4.76774C11.773 3.17284 10.3146 2.00065 8.58464 2.00065Z"
        fill="#413B56"
      />
    </svg>
  );
};

export default ScatteredCloudsIcon;
